import AddIcon from '@mui/icons-material/Add'
import {
    Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popover,
    Typography
} from '@mui/material'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import useTerminology from '@/hooks/useTerminology'
import { getVisibleNavItems } from '../nav-access'

export function SidebarPopout({
    anchorEl,
    open,
    onClose,
    section,
    navAccess,
    onMouseEnter,
    onMouseLeave,
    onCreateClick
}) {
    const { t } = useTerminology()
    const visibleItems = getVisibleNavItems(section.items, navAccess)

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            disableRestoreFocus={false}
            slotProps={{
                root: { style: { pointerEvents: 'none' } },
                paper: {
                    sx: { minWidth: 180, pointerEvents: 'auto' },
                    onMouseEnter,
                    onMouseLeave
                }
            }}
        >
            <Paper elevation={0}>
                <Typography
                    variant="overline"
                    sx={{
                        px: 2,
                        pt: 1,
                        display: 'block',
                        color: 'text.secondary'
                    }}
                >
                    {section.label}
                </Typography>
                <Divider />
                <List dense disablePadding>
                    {visibleItems.map((item) => (
                        <ListItemButton
                            key={item.id}
                            component={Link}
                            to={item.path}
                            onClick={onClose}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: 1.5,
                                    justifyContent: 'center'
                                }}
                            >
                                {item.icon ?? section.icon}
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    item.termKey ? t(item.termKey) : item.label
                                }
                            />
                        </ListItemButton>
                    ))}
                    {(section.createModal || section.createPath) &&
                        navAccess.isAuthenticated && (
                            <ListItemButton
                                {...(section.createModal
                                    ? {
                                          component: 'button',
                                          onClick: () => {
                                              onCreateClick(section)
                                              onClose()
                                          }
                                      }
                                    : {
                                          component: Link,
                                          to: section.createPath,
                                          onClick: onClose
                                      })}
                                sx={{ width: '100%' }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: 1,
                                        justifyContent: 'center'
                                    }}
                                >
                                    <AddIcon />
                                </ListItemIcon>
                                <ListItemText primary="Create" />
                            </ListItemButton>
                        )}
                </List>
            </Paper>
        </Popover>
    )
}

SidebarPopout.propTypes = {
    anchorEl: PropTypes.object,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    section: PropTypes.shape({
        label: PropTypes.string.isRequired,
        icon: PropTypes.element,
        items: PropTypes.array.isRequired,
        createPath: PropTypes.string,
        createModal: PropTypes.bool
    }).isRequired,
    navAccess: PropTypes.shape({
        isAuthenticated: PropTypes.bool.isRequired,
        isStaff: PropTypes.bool.isRequired,
        user: PropTypes.object
    }).isRequired,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onCreateClick: PropTypes.func
}
